<template>
  <div class="ds-manager__component empty-ds">
    <div class="ds-manager__component-title">
      <r-title type="title-2">
        {{ $t("ds-manager:creation:empty-ds:title") }}
      </r-title>
    </div>
    <div class="ds-manager__component-content">
      <el-row class="ds-manager__component-row">
        <el-col class="r-col" :span="12">
          <div class="ds-manager__component-subtitle">
            <r-text type="caption">
              {{ $t("ds-manager:creation:empty-ds:ds-name") }}</r-text
            >
          </div>
          <el-input
            class="r-input"
            size="mini"
            :placeholder="
              `${$t('ds-manager:creation:empty-ds:ds-name-placeholder')}`
            "
            v-model="dsName"
          ></el-input>
          <el-row class="ds-manager__component-row" style="margin-top:8px">
            <div class="ds-manager__component-subtitle">
              <r-text type="caption">
                {{ $t("ds-manager:creation:enter-profiles") }}</r-text
              >
            </div>
            <el-select
              class="r-select"
              size="mini"
              multiple
              collapse-tags
              v-model="selectedProfiles"
              :placeholder="
                `${$t('ds-manager:creation:select-profiles-placeholder')}`
              "
            >
              <el-option
                v-for="profile in profiles"
                :key="profile.id"
                :value="profile.id"
                :label="profile.name"
              />
            </el-select>
          </el-row>
        </el-col>
        <el-col class="r-col" :span="12">
          <div class="ds-manager__component-subtitle">
            <r-text type="caption">
              {{ $t("ds-manager:creation:empty-ds:geom-type") }}</r-text
            >
          </div>
          <el-select
            size="mini"
            class="r-select"
            v-model="geomType"
            :placeholder="
              `${$t('ds-manager:creation:empty-ds:geom-type-placeholder')}`
            "
            :no-match-text="`${$t('ds-manager:creation:no-match')}`"
            clearable
            filterable
          >
            <el-option
              v-for="subitem in geomTypes"
              :key="subitem"
              :label="$t(subitem)"
              :value="subitem"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="ds-manager__component-row">
        <ds-manager-table
          :attributes="attributes"
          :initialAttributes="initialAttributes"
          :changedRows="changedRows"
          :fields="fields"
          :types="types"
          :datasourcesList="datasourcesList"
          @nameValidation="nameValidation"
          @addAttribute="addAttribute"
          @deleteAttribute="deleteAttribute"
          @deleteAllAttribute="deleteAllAttribute"
        />
      </el-row>
      <el-row class="ds-manager__component-row text-right">
        <el-button
          class="r-button"
          size="mini"
          type="success"
          @click="createEmptyDs"
          :disabled="!isCreateReady"
        >
          {{ $t("ds-manager:creation:create-ds") }}
        </el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import dsManagerTable from "../ds-manager-table/ds-manager-table";

import { notifyFactory, errorParser } from "@/utils";

const fields = [
  { label: "name", prop: "title", type: "name" },
  { label: "type", prop: "type", type: "belongs_to" },
  { label: "default", prop: "default", type: "string" },
  { label: "time field", prop: "time_field", type: "bool" }
];

export default {
  components: { dsManagerTable },
  data() {
    return {
      dsName: "",
      types: [],
      geomTypes: [],
      geomType: "point",

      attributes: [],
      initialAttributes: [],
      changedRows: [],
      newRows: [],
      selectedProfiles: [],
      allNamesCorrect: true,

      fields
    };
  },
  watch: {
    hasChanges(val) {
      this.$store.commit("MODAL_WINDOW_ACTIVE_TOGGLER", val);
    }
  },
  computed: {
    isCreateReady() {
      if (
        !this.attributes.length ||
        !this.dsName.trim() ||
        !this.geomType ||
        !this.geomType.trim() ||
        !this.allNamesCorrect
      )
        return false;

      const isTitleEmpty = this.attributes.find(
        e => !e.title || !e.title.trim().length
      );
      const isTypeEmpty = this.attributes.find(
        e => !e.type || !e.type.trim().length
      );

      return !(isTitleEmpty || isTypeEmpty);
    },
    hasChanges() {
      if (this.attributes.length || this.dsName.trim()) return true;

      return false;
    },
    datasourcesList() {
      return (
        Object.keys(this.$store.state.datasources).map(
          ds => this.$store.state.datasources[ds]
        ) || []
      );
    },
    profiles() {
      return this.$store.state.profiles.profilesTree;
    },
    currentProfile() {
      return this.$store.state.profiles.currentProfile;
    }
  },
  methods: {
    async createEmptyDs() {
      try {
        const data = new FormData();
        data.append("data_source_name", this.dsName);
        data.append("type", "custom");

        const attributes = [...this.attributes];
        attributes.push({ title: "geom", type: this.geomType });
        data.append("fields", JSON.stringify(attributes));
        data.append("user_profile_id", this.selectedProfiles.join());

        const response = await this.$store.dispatch("SEND_FORM_DATA", {
          url: "import_data",
          data
        });
        const title = this.$t("ds-manager:creation:create-success-title");
        const message = `${this.$t(
          "ds-manager:creation:create-success-text"
        )} ${response.data.task_id}`;
        this.$notify(notifyFactory("success", title, message));
        this.$store.commit("ADD_ACTIVE_TASK", {
          task_id: response.data.task_id,
          type: "import",
          description: `Импорт ИД - ${this.layerName}`
        });
        this.clearAll();
      } catch (e) {
        errorParser.call(this, e);
      }
    },
    clearAll() {
      this.deleteAllAttribute();
      this.dsName = "";
      this.geomType = "";
    },
    async loadTypes() {
      try {
        const { data } = await this.$store.dispatch("REQUEST", {
          url: `datatypes`
        });

        this.types = data.base || [];
        this.geomTypes = data.geom || [];
      } catch (e) {
        console.log(e);
      }
    },
    nameValidation(val) {
      this.allNamesCorrect = val;
    },
    addAttribute() {
      const attribute = {
        title: null,
        type: "string",
        default: null,
        source_id: null,
        time_field: null
      };
      this.attributes.push(attribute);
    },
    deleteAttribute(row) {
      const index = this.attributes.findIndex(item => item.title === row.title);
      const newIndex = this.newRows.findIndex(item => item === row.title);
      this.attributes.splice(index, 1);
      if (newIndex > -1) this.newRows.splice(newIndex, 1);
    },
    deleteAllAttribute() {
      this.attributes.splice(0, this.attributes.length);
    }
  },
  created() {
    this.loadTypes();
    this.selectedProfiles = this.profiles
      .filter(e => e.id === this.currentProfile.id)
      .map(e => e.id);
  },
  beforeDestroy() {
    this.$store.commit("MODAL_WINDOW_ACTIVE_TOGGLER", false);
  }
};
</script>

<style lang="scss">
.empty-ds {
  .ds-manager__component-content {
    width: 800px;
    height: 468px;
    .r-select {
      width: 100%;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "ds-manager:creation:empty-ds:title": "Создать пустой источник данных",
    "ds-manager:creation:empty-ds:ds-name": "Укажите название",
    "ds-manager:creation:empty-ds:ds-name-placeholder": "Название",
    "ds-manager:creation:empty-ds:geom-type": "Укажите тип геометрии",
    "ds-manager:creation:empty-ds:geom-type-placeholder": "Тип геометрии",
    "ds-manager:creation:enter-profiles": "Выберите профили",
    "ds-manager:creation:select-profiles-placeholder": "Выберите профили в которые добавить источник данных",
    
    "ds-manager:creation:no-match": "Нет совпадений",

    "ds-manager:creation:create-ds": "Создать источник данных",

    "ds-manager:creation:create-success-title": "Запрос отправлен",
    "ds-manager:creation:create-success-text": "Запрос на создание источника данных отправлен. Номер задачи - "
  },
  "en": {
    "ds-manager:creation:empty-ds:title": "Create an empty data source",
    "ds-manager:creation:empty-ds:ds-name": "Enter name",
    "ds-manager:creation:empty-ds:ds-name-placeholder": "Name",
    "ds-manager:creation:empty-ds:geom-type": "Enter geometry type",
    "ds-manager:creation:empty-ds:geom-type-placeholder": "Geometry type",
    "ds-manager:creation:enter-profiles": "Select profiles",
    "ds-manager:creation:select-profiles-placeholder": "Select the profiles to add the source to",
    
    "ds-manager:creation:no-match": "No match",
    
    "ds-manager:creation:create-ds": "Create data source",

    "ds-manager:creation:create-success-title": "Request sent",
    "ds-manager:creation:create-success-text": "A request to create a data source has been sent. Task number -"
  }
}
</i18n>
